import { render, staticRenderFns } from "./ViewPage.vue?vue&type=template&id=98f31898&scoped=true&"
import script from "./ViewPage.vue?vue&type=script&lang=js&"
export * from "./ViewPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewPage.vue?vue&type=style&index=0&id=98f31898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f31898",
  null
  
)

export default component.exports